// src/components/Product/CarpetFlipper.jsx

'use client';

import { useState, useEffect, useTransition } from 'react';
import ThreeSixtyIcon from '@mui/icons-material/ThreeSixty';
import styles from './CarpetFlipper.module.scss';


export default function CarpetFlipper({ frontImage, backImage, productPageSizes, isSold }) {
  // Return null if essential image properties are missing
  if (!frontImage?.url || !frontImage?.width || !frontImage?.height || 
      !backImage?.url || !backImage?.width || !backImage?.height) {
    return null;
  }

  const [flipped, setFlipped] = useState(false);
  const [isPending, startTransition] = useTransition();
  const [timeLeft, setTimeLeft] = useState(15);

  useEffect(() => {
    let timer;
    let countdownTimer;

    if (flipped) {
      setTimeLeft(15);

      countdownTimer = setInterval(() => {
        setTimeLeft(prev => Math.max(0, prev - 1));
      }, 1000);

      timer = setTimeout(() => {
        startTransition(() => {
          setFlipped(false);
        });
      }, 15000); // Auto flip back after 15 seconds
    }

    return () => {
      clearTimeout(timer);
      clearInterval(countdownTimer);
    };
  }, [flipped]);

  const handleFlip = () => {
    startTransition(() => {
      setFlipped(!flipped);
    });
  };

  return (
    <>
      <div className={`${styles.carpetContainer} ${flipped ? styles.flipped : ''}`}>
        <div className={styles.carpetFlipper}>
          <div className={styles.carpetFront}>
            <img
              src={frontImage.url}
              width={frontImage.width}
              height={frontImage.height}
              alt="Carpet front side"
              sizes={productPageSizes}
              className={isSold ? 'sold' : ''}
            />
          </div>
          <div className={styles.carpetBack}>
            <img
              src={backImage.url}
              width={backImage.width}
              height={backImage.height}
              alt="Carpet back side"
              sizes={productPageSizes}
              className={isSold ? 'sold' : ''}
            />
            {flipped && <div className={styles.flipTimer}>{timeLeft}s</div>}
          </div>
        </div>
      </div>

      <button
        onClick={handleFlip}
        className={styles.flipButton}
        disabled={isPending}
        aria-pressed={flipped}
      >
        <ThreeSixtyIcon />
        {isPending ? 'Flipping...' : flipped ? 'View Front Side' : 'View Back Side'}
      </button>
    </>
  );
}
